// extracted by mini-css-extract-plugin
export var field = "searchbar-module--field--6052b";
export var label = "searchbar-module--label--a1de7";
export var searchform = "searchbar-module--searchform--29a87";